<div *ngIf="openMeetingRoom" class="modal fixed w-screen h-full top-0 left-0 flex z-[1000] p-5 lg:p-0">
  <div class="meetingElement">
    <div #meetingSDKElement id="meetingSDKElement"></div>
    <button (click)="close()">Sair do Atendimento</button>
  </div>
</div>
<app-service-information></app-service-information>
